import React from "react";

const MerchantName = ({ name }) => {
  return (
    <h1 className="sl-title-bloc sl-title" itemProp="name">
      {name}
    </h1>
  );
};

export default MerchantName;